import { render, staticRenderFns } from "./InTheNewsSection.vue?vue&type=template&id=5603ca56&scoped=true&"
import script from "./InTheNewsSection.vue?vue&type=script&lang=ts&"
export * from "./InTheNewsSection.vue?vue&type=script&lang=ts&"
import style0 from "./InTheNewsSection.vue?vue&type=style&index=0&id=5603ca56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603ca56",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
